export const messageTypeList = {
    permissionUpdate: 'permission_update',
    notificationCountUpdate: 'notification_count_update',
    appSettingUpdate: 'app_setting_update',
    appImageUpdate: 'app_image_update',
    myTasksNotificationCountUpdate: 'my_tasks_notification_count_update',
};
